import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type PortalStartInvoiceCheckoutMutationVariables = Types.Exact<{
  tenantId: Types.Scalars['String']['input'];
  invoiceIds: Array<Types.Scalars['String']['input']> | Types.Scalars['String']['input'];
}>;


export type PortalStartInvoiceCheckoutMutation = { __typename?: 'Mutation', customerPortalStartInvoiceCheckout: { __typename?: 'CustomerPortalInvoiceCheckoutStartPayload', checkoutUrl?: string | null, attemptId?: string | null, refusal?: { __typename?: 'InvoiceCheckoutRefusal', code: Types.InvoiceCheckoutRefusalCode, retryable: boolean, message: string } | null } };


export const PortalStartInvoiceCheckoutDocument = new TypedDocumentString(`
    mutation PortalStartInvoiceCheckout($tenantId: String!, $invoiceIds: [String!]!) {
  customerPortalStartInvoiceCheckout(tenantId: $tenantId, invoiceIds: $invoiceIds) {
    checkoutUrl
    attemptId
    refusal {
      ...PortalInvoiceCheckoutRefusal
    }
  }
}
    fragment PortalInvoiceCheckoutRefusal on InvoiceCheckoutRefusal {
  code
  retryable
  message
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    PortalStartInvoiceCheckout: build.mutation<PortalStartInvoiceCheckoutMutation, PortalStartInvoiceCheckoutMutationVariables>({
      query: (variables) => ({ document: PortalStartInvoiceCheckoutDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { usePortalStartInvoiceCheckoutMutation } = injectedRtkApi;
